"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileIcon = FileIcon;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var Components = _interopRequireWildcard(require("../components"));
var _fileTypeIcons = require("./fileTypeIcons");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["extensionName", "isFolder", "isLink"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const iconMap = {
  illustrator: Components.Illustrator,
  air: Components.Air,
  word: Components.Docx,
  encapsulatedPostScript: Components.Eps,
  flash: Components.Flash,
  indesign: Components.Indesign,
  audio: Components.Audio,
  noteworthyComposer: Components.Nwc,
  navisworks: Components.Nwf,
  pdf: Components.Pdf,
  powerpoint: Components.Pptx,
  onetoc: Components.Onetoc,
  csv: Components.Csv,
  dotx: Components.Dotx,
  mpt: Components.Mpt,
  potx: Components.Potx,
  ppsx: Components.Ppsx,
  vssx: Components.Vssx,
  vstx: Components.Vstx,
  xltx: Components.Xltx,
  photoshop: Components.Photoshop,
  quickbooksBackup: Components.QuickbooksBasic,
  quickbooksWindows: Components.QuickbooksWhite,
  rivet: Components.Rvt,
  video: Components.Videos,
  excel: Components.Xlsx,
  zip: Components.ZipFile,
  code: Components.Code,
  image: Components.Images,
  text: Components.Text,
  cad: Components.Dwg,
  keynote: Components.Keynote,
  diskCatalogMaker: Components.Dcm,
  access: Components.Mdb,
  project: Components.Mpp,
  numbers: Components.Numbers,
  pages: Components.Pages,
  publisher: Components.Pub,
  visio: Components.Vsd,
  sketch: Components.Sketch,
  onenote: Components.One,
  email: Components.Email,
  xsn: Components.Xsn,
  vsdx: Components.Vsdx,
  accdb: Components.Accdb
};
const shortcutIconMap = {
  illustrator: Components.IllustratorShortcut,
  air: Components.AirShortcut,
  word: Components.DocxShortcut,
  encapsulatedPostScript: Components.EpsShortcut,
  flash: Components.FlashShortcut,
  indesign: Components.IndesignShortcut,
  audio: Components.AudioShortcut,
  noteworthyComposer: Components.NwcShortcut,
  navisworks: Components.NwfShortcut,
  pdf: Components.PdfShortcut,
  powerpoint: Components.PptxShortcut,
  photoshop: Components.PhotoshopShortcut,
  quickbooksBackup: Components.QuickbooksBasicShortcut,
  quickbooksWindows: Components.QuickbooksWhiteShortcut,
  rivet: Components.RvtShortcut,
  video: Components.VideosShortcut,
  excel: Components.XlsxShortcut,
  zip: Components.ZipFileShortcut,
  code: Components.CodeShortcut,
  image: Components.ImagesShortcut,
  text: Components.TextShortcut,
  cad: Components.DwgShortcut,
  keynote: Components.KeynoteShortcut,
  diskCatalogMaker: Components.DcmShortcut,
  access: Components.MdbShortcut,
  project: Components.MppShortcut,
  numbers: Components.NumbersShortcut,
  pages: Components.PagesShortcut,
  publisher: Components.PubShortcut,
  visio: Components.VsdShortcut,
  sketch: Components.SketchShortcut,
  onenote: Components.OneShortcut,
  email: Components.EmailShortcut,
  onetoc: Components.OnetocShortcut,
  csv: Components.CsvShortcut,
  dotx: Components.DotxShortcut,
  mpt: Components.MptShortcut,
  ppsx: Components.PpsxShortcut,
  potx: Components.PotxShortcut,
  vssx: Components.VssxShortcut,
  vstx: Components.VstxShortcut,
  xltx: Components.XltxShortcut,
  xsn: Components.XsnShortcut,
  vsdx: Components.VsdxShortcut,
  accdb: Components.AccdbShortcut
};
function getIconFromMap(iconType, isLink) {
  return isLink ? shortcutIconMap[iconType] : iconMap[iconType];
}
function getDefaultComponent(isLink) {
  return isLink ? Components.UnknownShortcut : Components.Unknown;
}
function getIconComponent(iconType, isLink) {
  if (iconType) {
    return getIconFromMap(iconType, isLink) || getDefaultComponent(isLink);
  }
  return getDefaultComponent(isLink);
}
function FileIcon(props) {
  const {
      extensionName,
      isFolder,
      isLink
    } = props,
    iconProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  let IconComponent;
  if (isFolder) {
    IconComponent = isLink ? Components.FolderIconShortcut : Components.FolderIcon;
  } else {
    const iconType = extensionName ? (0, _fileTypeIcons.getIconTypeByExtension)(extensionName) : null;
    IconComponent = getIconComponent(iconType, isLink !== null && isLink !== void 0 ? isLink : false);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, _objectSpread({}, iconProps));
}